var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.state == "form"
    ? _c("app-create-pdf-archive-modal-form", {
        attrs: { "browse-state": _vm.browseState },
        on: {
          close: function ($event) {
            return _vm.close()
          },
          create: function ($event) {
            return _vm.create($event)
          },
        },
      })
    : _vm.state == "creating"
    ? _c("app-create-pdf-archive-modal-progress", {
        attrs: { job: _vm.job },
        on: {
          close: function ($event) {
            return _vm.close()
          },
        },
      })
    : _vm.state == "done"
    ? _c("app-create-pdf-archive-modal-created", {
        attrs: { "created-archive": _vm.createdArchive },
        on: {
          close: function ($event) {
            return _vm.close()
          },
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }